import { DeviceType } from '../../types/DeviceType';
import { DesktopModalSize, MobileModalSize } from '../../common.constants';
import { InstallmentPaymentMethod } from '../../types/InstallmentPaymentMethod';

export const AFFIRM_MODAL_SIZE = {
  [DeviceType.Desktop]: DesktopModalSize[InstallmentPaymentMethod.Affirm],
  [DeviceType.Mobile]: MobileModalSize,
};
